"use client";

import { useEffect } from "react";
import { getToken } from "@/lib/api";

const API_BASE = process.env.NEXT_PUBLIC_API_BASE_URL ?? "http://localhost:8000";

/** Registers the service worker that makes Rankbist installable, shows the
 *  offline page when there's no connection and receives push notifications.
 *  Registered automatically in production; in development only once someone
 *  turns notifications on (lib/push.ts), so local pages are never cached.
 *  When the browser rotates a push subscription, the new one is sent to the
 *  server so notifications keep arriving. */
export function ServiceWorker() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const onMessage = (e: MessageEvent) => {
      const data = e.data as { type?: string; subscription?: { endpoint: string; keys: { p256dh: string; auth: string } } } | null;
      const token = getToken();
      if (data?.type !== "rb-push-resubscribe" || !data.subscription || !token) return;
      fetch(`${API_BASE}/api/push/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ endpoint: data.subscription.endpoint, keys: data.subscription.keys }),
      }).catch(() => {});
    };
    navigator.serviceWorker.addEventListener("message", onMessage);
    if (process.env.NODE_ENV === "production") {
      const register = () => navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
      if (document.readyState === "complete") register();
      else window.addEventListener("load", register, { once: true });
    }
    return () => navigator.serviceWorker.removeEventListener("message", onMessage);
  }, []);
  return null;
}
